import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../../components/header/Header";
// import { checkParams } from "../../../src/util/Util";

const VerifyPhone = (props) => {
  let navigate = useNavigate();
  const [messageActive, setMessageActive] = useState(false);
  const [code, setCode] = useState("");
  const [errorCode, setErrorCode] = useState("");

  useEffect(() => {
    props.actSidebar(false);
    props.checkLoggedIn(false);
    localStorage.removeItem("userCompanyData");
    // eslint-disable-next-line
  }, []);

  const resendCode = (onload) => {
    var sendObj = {};
    var route = "user/login";
    var phone = localStorage.getItem("phone");
    if (phone.length > 0) {
      sendObj = { phone };
      route = "user/phone_login";
    }
    axios
      .post(window.ajaxLink + route, sendObj)
      .then((res) => {
        if (res.data.responseCode === 200) {
          //localStorage.setItem("userData", JSON.stringify(res.data.responseData));
          //props.checkLoggedIn(true);
          if (!onload) {
            setMessageActive(true);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const verifyOtp = () => {
    if (code) {
      axios
        .post(window.ajaxLink + "user/phone_auth", {
          phone: localStorage.getItem("phone"),
          smsCode: code,
        })
        .then((res) => {
          if (res.data.responseCode === 200) {
            localStorage.setItem("userData", JSON.stringify(res.data.responseData));
            if (res.data.responseData.userType === 1) {
              props.checkLoggedIn(true);
              navigate("/initial_questionare");
              localStorage.removeItem("company_id");
            } else if (res.data.responseData.userType === 2) {
              props.checkLoggedIn(true);
              navigate("/dashboard");
            }
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.response.data.errorData.codeErr) {
            setErrorCode(error.response.data.errorData.codeErr);
          }
        });
    }
  };

  return (
    <div style={{paddingBottom: '2rem'}}>
      {messageActive && (
        <div className="header_resent">
          <div className="verify_msg_box"></div>
          <div className="verify_hdr_text">
            A verification code has been resent to
            <span>{" " + localStorage.getItem("phone") + ". "}</span>
            Please enter it once you receive the text message
          </div>
          <div className="verify_hdr_text verify_hdr_dis" onClick={() => setMessageActive(false)}>
            Dismiss
          </div>
        </div>
      )}
      <Header />
      <div className={"verify_container" + (messageActive ? " verify_cont_msg_active" : "")}>
        <div
          className="previous_btn verify_prev_button"
          onClick={() => navigate(localStorage.getItem("isNew") ? "/register" : "/login")}
        >
          <div className="back_arrow_btn"></div>
        </div>
        <div className="cloud_verify_holder">
          <div className="verify_title" style={{ fontSize: "27px" }}>
            Sign in with your mobile number
          </div>
          <div className="verify_explain">
            Enter the verification code we texted to <span>{localStorage.getItem("phone")}.</span>
          </div>
          <div className="verify_form_title">Verification code</div>
          <input
            type="text"
            tabIndex="1"
            className="reg_input verify_input"
            onChange={(e) => setCode(e.target.value)}
          />
          {errorCode && <div className="email_error_msg email_error_pdng_bottom">{errorCode}</div>}
          <div className="verify_actions">
            <div className="verify_action_desc">Didn’t receive the code?</div>
            <div className="verify_action_trigger" onClick={() => resendCode()}>
              Resend Code
            </div>
          </div>
          <div className="verify_actions">
            <div className="verify_action_desc">Not working?</div>
            <div className="verify_action_trigger" onClick={() => navigate("/login")}>
              Sign in with email
            </div>
          </div>
          <div className="verify_info">
            <div className="verify_info_inner">
              <div className="verify_info_left">
                <div className="verify_info_sign"></div>
              </div>
              <div className="verify_info_text_box">
                Please make sure to check your tabs Updates, Promotions, Forums, and Spam Folder
              </div>
            </div>
          </div>
          <div className={"signNewButton" + (code.length > 0 ? "" : " reg_procc_disabled")} onClick={() => verifyOtp()}>
            Continue
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyPhone;
